import { ChangeDetectionStrategy, Component, Inject, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PDialogFooterBtnActionType, PDialogFooterBtnConfig, POkCancelDialogData } from '../';
import { TextAreaEnum } from '@panaya/ui/p-field-text';

@Component({
    selector: 'p-confirm-with-comment-dialog',
    template: `
        <p-dialog [headerText]="headerText" [btnConfig]="footerBtnConfig" [footerTemplate]="footerTemplate">
            <div class="modal-body simple-dialog-body p-dialog-content" [innerHTML]="bodyText"></div>
            <div class="modal-body simple-dialog-body p-dialog-content comment-text-area" [innerHTML]="commentText"></div>
            <div class="p-dialog-content comment-area">
                <p-field-text
                    customClasses="clear-auto-width"
                    [attr.automation-id]="data.automationIdPrefix + 'comment_textarea'"
                    [size]="commentTextareaSize"
                    fxFlex
                    [isMultiline]="true"
                    [(ngModel)]="comment"
                    [placeholder]="placeholder"
                >
                </p-field-text>
            </div>
        </p-dialog>
    `,
    styleUrls: ['./p-confirm-with-comment-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PConfirmWithCommentDialogComponent implements OnInit {
    headerText?: string;
    isSentenceCase?: boolean = true;
    bodyText?: string;
    commentText?: string = '';
    comment = '';
    footerBtnConfig: PDialogFooterBtnConfig[] = [];
    footerTemplate?: TemplateRef<HTMLElement>;
    okText?: string;
    cancelText?: string;
    placeholder: string = '';

    commentTextareaSize = TextAreaEnum.FullWidth;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: PConfirmWithCommentDialogData,
        private dialogRef: MatDialogRef<boolean>
    ) {}

    ngOnInit(): void {
        this.headerText = this.data.headerText;
        this.isSentenceCase = this.data.isSentenceCase;
        this.bodyText = this.data.bodyText;
        this.okText = this.data.okText;
        this.cancelText = this.data.cancelText;
        this.commentText = this.data.additionalText;
        this.footerTemplate = this.data.footerTemplate;
        this.placeholder = this.data.placeholder || '';
        this.setFooterBtnConfig();
    }

    onOkClick(): void {
        this.dialogRef.close({ comment: this.comment });
    }

    private setFooterBtnConfig(): void {
        this.footerBtnConfig.push({
            click: () => this.onOkClick(),
            text: this.okText || 'Actions.ok'
        });

        this.footerBtnConfig.push({
            type: PDialogFooterBtnActionType.Close,
            text: this.cancelText || 'Actions.cancel'
        });
    }
}

export interface PConfirmWithCommentDialogData extends POkCancelDialogData {
    placeholder?: string;
    footerTemplate?: TemplateRef<HTMLElement>;
}
